import axios from "axios";
import {
  Timestamp,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { collectionData, docData } from "rxfire/firestore";
import { tap } from "rxjs/operators";
import { store } from "../";
import { notification$, totaltransaction$ } from "../redux/action";
import { db } from "./firebase";

import { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";

const current_timestamp = Timestamp.fromDate(new Date());

export const CurrencyFormat = ({ amount, prefix, seperator }) => {
  return (
    <NumericFormat
      thousandSeparator={seperator}
      displayType={"text"}
      prefix={prefix}
      value={amount}
      decimalScale={2}
      fixedDecimalScale
    />
  );
};

export const CryptoCurrencyFormat = ({ amount, suffix }) => {
  return (
    <NumericFormat
      thousandSeparator={false}
      displayType={"text"}
      // suffix={suffix}
      value={amount}
      decimalScale={3}
      fixedDecimalScale
    />
  );
};

export const addUsers = async (docid, userdatas) => {
  const querydoc = doc(db, `users/${docid}`);
  await setDoc(querydoc, userdatas, { merge: true });
};

export const creditWallet = async (userid, wallet, data) => {
  const querydoc = doc(db, "users", `${userid}`, "wallet", wallet);
  await setDoc(querydoc, data, { merge: true });
};

export const getUserInfo = (userid) => {
  const querydoc = doc(db, `users/${userid}`);
  return docData(querydoc);
};

export const getTransactions = (userid) => {
  const transactionref = query(
    collection(db, "users", `${userid}`, "transactions"),
    where("main", "==", true)
  );
  return collectionData(transactionref, { idField: "uid" })
    .pipe(
      tap((transactions) => console.log("This is all transaction observable!"))
    )
    .subscribe((trans) => {
      console.log(trans.length);
      store.dispatch(totaltransaction$(trans.length));
    });
};

export const getTransactionsType = async (userid, coinType) => {
  const transactionref = query(
    collection(db, "users", `${userid}`, "transactions"),
    where("cointitle", "==", coinType),
    orderBy("timestamp", "desc")
  );
  const querySnapshot = await getDocs(transactionref);
  return querySnapshot;
};

export const addTransfer = async (userid, data) => {
  const docRef = doc(collection(db, "users", userid, "transactions"));

  return await setDoc(docRef, { ...data, timestamp: current_timestamp });
};

export const updateUserBalance = (userid, cointype, balance) => {
  const querydoc = doc(db, `users/${userid}`);
  console.log(balance);
  return setDoc(querydoc, { [cointype]: Number(balance) }, { merge: true });
};

export const getallusers = () => {
  const collectionRef = collection(db, "users");
  const q = query(collectionRef, orderBy("timestamp", "desc"));
  return collectionData(q, { idField: "uid" });
};

export const getuserDataAdmin = (id) => {
  const davidDocRef = doc(db, `users/${id}`);
  return docData(davidDocRef, { idField: "uid" });
};

export const getuserDataBalanceAdmin = (id, type) => {
  const DocRef = doc(db, "users", `${id}`, "account", type);
  return docData(DocRef, { idField: "uid" });
};

export const updateuserDataBalanceAdmin = (id, type, balance) => {
  const DocRef = doc(db, "users", `${id}`, "account", type);
  setDoc(DocRef, { balance: parseInt(balance) }, { merge: true });
  alert("User info has been updated successfully");
};

export const activateAccount = async (uid, current) => {
  const DocRef = doc(db, "users", `${uid}`);
  await setDoc(
    DocRef,
    { activated: current, Verificationstatus: current },
    { merge: true }
  );
};

export const getallWalletTransaction = () => {
  const collectionRef = collection(db, "transactionswallet");
  const q = query(collectionRef, orderBy("timestamp", "desc"));
  return collectionData(q, { idField: "uid" });
};

export const getallUserTrans = (id) => {
  const collectionRef = collection(db, "users", id, "transactions");
  const q = query(collectionRef, orderBy("timestamp", "desc"));
  return collectionData(q, { idField: "uid" });
};

export const addNotification = async (id, title, message) => {
  const DocRef = doc(collection(db, "users", `${id}`, "notification"));
  await setDoc(DocRef, { title: title, message: message });
};

export const getNotification = (id) => {
  const notificationRef = query(
    collection(db, "users", `${id}`, "notification")
  );
  return collectionData(notificationRef, { idField: "uid" }).subscribe(
    (data) => {
      store.dispatch(notification$(data));
    }
  );
};

export const deletedocument = async (id) => {
  await deleteDoc(doc(db, "users", id));
};

export const sendMessage = (message, subject, email, name) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify({
    message: message,
    to: `anthonyerics84@gmail.com, ${email}`,
    subject: subject,
    name: name,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  return fetch("https://expresspage.vercel.app/teglat", requestOptions).then(
    (response) => response.text()
  );
};

const PRICE_CACHE_KEY = "crypto_usd_prices";
const PRICE_CACHE_TTL = 5 * 60 * 1000; // 5 minutes — avoid CoinGecko rate limits

const FALLBACK_PRICES = {
  BTC: 65000,
  ETH: 3500,
  BNB: 600,
  TRX: 0.12,
  USDT: 1,
};

const FALLBACK_CHANGES = {
  BTC: 0,
  ETH: 0,
  BNB: 0,
  TRX: 0,
  USDT: 0,
};

const loadCachedPrices = () => {
  try {
    const cached = JSON.parse(localStorage.getItem(PRICE_CACHE_KEY));
    if (cached?.prices && cached?.fetchedAt) {
      return {
        prices: { ...FALLBACK_PRICES, ...cached.prices },
        changes: { ...FALLBACK_CHANGES, ...cached.changes },
        fetchedAt: cached.fetchedAt,
      };
    }
  } catch (error) {
    console.log(error);
  }
  return {
    prices: { ...FALLBACK_PRICES },
    changes: { ...FALLBACK_CHANGES },
    fetchedAt: 0,
  };
};

let priceState = loadCachedPrices();
let pendingPriceFetch = null;

export const normalizeCoinCode = (code) => {
  const value = String(code || "").toUpperCase();
  if (value.startsWith("BTC")) return "BTC";
  if (value.startsWith("ETH")) return "ETH";
  if (value.startsWith("BNB")) return "BNB";
  if (value.startsWith("TRX") || value === "TRON") return "TRX";
  return "USDT";
};

/** Sync read of last known prices (memory + localStorage fallbacks). */
export const getCachedPrices = () => priceState;

/**
 * Fetch CoinGecko prices with in-memory + localStorage cache.
 * On 429 / network errors, returns cached prices instead of throwing.
 */
export const fetchCryptoPrices = async (force = false) => {
  const now = Date.now();
  if (!force && now - priceState.fetchedAt < PRICE_CACHE_TTL) {
    return priceState;
  }
  if (pendingPriceFetch) {
    return pendingPriceFetch;
  }

  pendingPriceFetch = axios
    .get(
      "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin%2Cethereum%2Cbinancecoin%2Ctron%2Ctether%2C&vs_currencies=usd&include_24hr_change=true"
    )
    .then((res) => {
      priceState = {
        prices: {
          BTC: res.data.bitcoin.usd,
          ETH: res.data.ethereum.usd,
          BNB: res.data.binancecoin.usd,
          TRX: res.data.tron.usd,
          USDT: res.data.tether.usd,
        },
        changes: {
          BTC: Number(res.data.bitcoin.usd_24h_change) || 0,
          ETH: Number(res.data.ethereum.usd_24h_change) || 0,
          BNB: Number(res.data.binancecoin.usd_24h_change) || 0,
          TRX: Number(res.data.tron.usd_24h_change) || 0,
          USDT: Number(res.data.tether.usd_24h_change) || 0,
        },
        fetchedAt: Date.now(),
      };
      try {
        localStorage.setItem(PRICE_CACHE_KEY, JSON.stringify(priceState));
      } catch (error) {
        console.log(error);
      }
      return priceState;
    })
    .catch((error) => {
      // 429 / network — keep last known prices and extend TTL so we don't hammer
      console.log(error);
      priceState = { ...priceState, fetchedAt: Date.now() };
      try {
        localStorage.setItem(PRICE_CACHE_KEY, JSON.stringify(priceState));
      } catch (e) {
        console.log(e);
      }
      return priceState;
    })
    .finally(() => {
      pendingPriceFetch = null;
    });

  return pendingPriceFetch;
};

export const coinToUsd = (amount, code) => {
  const price = priceState.prices[normalizeCoinCode(code)] || 1;
  return Number(amount) * price;
};

export const usdToCoin = (amount, code) => {
  const price = priceState.prices[normalizeCoinCode(code)] || 1;
  return Number(amount) / price;
};

export const coinToCoin = (amount, fromCode, toCode) => {
  return usdToCoin(coinToUsd(amount, fromCode), toCode);
};

/** Build wallet list from USD balances + cached CoinGecko prices (no API call). */
export const buildWalletData = (balances) => {
  const { prices, changes } = getCachedPrices();
  const {
    btc_balance = 0,
    eth_balance = 0,
    bnb_balance = 0,
    tron_balance = 0,
    usdt_balance = 0,
    usdterc20_balance = 0,
  } = balances;

  const myArray = [
    {
      coinname: "BITCOIN",
      cointype: "btc_balance",
      price: prices.BTC,
      difference: changes.BTC,
      balance: btc_balance,
      balancecoin: usdToCoin(btc_balance, "BTC"),
      code: "BTC",
      codeswap: "BTC",
      image: "./images/coins/btc.png",
      address: "bc1qvcny9273tekt7cg85k9kt2g5k0dhpwdrjp356x",
      network: "BTC",
      thumbimage: "./images/coins/btc.png",
      contractaddress: false,
    },
    {
      coinname: "ETHERUEM",
      cointype: "eth_balance",
      price: prices.ETH,
      difference: changes.ETH,
      balance: eth_balance,
      balancecoin: usdToCoin(eth_balance, "ETH"),
      code: "ETH",
      codeswap: "ETH",
      image: "./images/coins/eth.png",
      address: "0x2F39B4eC094DF801837b338211933E2d425fb332",
      network: "ERC20",
      thumbimage: "./images/coins/eth.png",
      contractaddress: false,
    },
    {
      coinname: "BNB SMART",
      cointype: "bnb_balance",
      price: prices.BNB,
      difference: changes.BNB,
      balance: bnb_balance,
      balancecoin: usdToCoin(bnb_balance, "BNB"),
      code: "BNB",
      codeswap: "BNB",
      image: "./images/coins/bnb.png",
      address: "bnb13m39rjwfj7kjpeh627d8hmfx2k9xgwckvm2lmn",
      network: "BEP20",
      thumbimage: "./images/coins/bnb.png",
      contractaddress: false,
    },
    {
      coinname: "TRON",
      cointype: "tron_balance",
      price: prices.TRX,
      difference: changes.TRX,
      balance: tron_balance,
      balancecoin: usdToCoin(tron_balance, "TRX"),
      code: "TRX",
      codeswap: "TRX",
      image: "./images/coins/tron.png",
      address: "TZ9YZp1CjnL5o4YFifhWGwE6DdVAvmebJg",
      network: "TRC20",
      thumbimage: "./images/coins/tron.png",
      contractaddress: false,
    },
    {
      coinname: "USDT",
      cointype: "usdt_balance",
      price: prices.USDT,
      difference: changes.USDT,
      balance: usdt_balance,
      balancecoin: usdToCoin(usdt_balance, "USDT"),
      code: "USDT TRC20",
      codeswap: "USDT",
      image: "./images/coins/usdt.png",
      address: "TZ9YZp1CjnL5o4YFifhWGwE6DdVAvmebJg",
      network: "TRC20",
      thumbimage: "./images/coins/tron.png",
      contractaddress: true,
    },
    {
      coinname: "USDT",
      cointype: "usdterc20_balance",
      price: prices.USDT,
      difference: changes.USDT,
      balance: usdterc20_balance,
      balancecoin: usdToCoin(usdterc20_balance, "USDT"),
      code: "USDT ERC20",
      codeswap: "USDT",
      image: "./images/coins/usdt.png",
      address: "0x2F39B4eC094DF801837b338211933E2d425fb332",
      network: "ERC20",
      thumbimage: "./images/coins/eth.png",
      contractaddress: true,
    },
  ];

  myArray.sort((a, b) => b.balance - a.balance);
  return myArray;
};

export const Price = function ({ amount }) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    (async function () {
      await fetchCryptoPrices();
      setValue(coinToUsd(amount, "ETH"));
    })();
  }, [amount]);

  return (
    <>
      You will receive{" "}
      <CurrencyFormat amount={value} prefix="$" seperator={true} /> USD
    </>
  );
};

export const getWhatsapp = async () => {
  const querydoc = doc(db, `whatsapp/number`);
  const data = await getDoc(querydoc);
  return data.data();
};
